import { _ as e } from "./extends-093996c9.js";
import t from "react";

var h = function h(_h) {
  var a = _h.dark,
      v = void 0 === a ? "#000000" : a,
      r = _h.light,
      l = void 0 === r ? "#ffffff" : r,
      o = _h.schema,
      m = {
    isotypebox: v,
    isotypeletter: v,
    letters: v
  };
  return "light" === (void 0 === o ? "common" : o) && (m.isotypebox = l, m.isotypeletter = l, m.letters = l), t.createElement("svg", e({
    viewBox: "0 0 637.9 110.38"
  }, _h), t.createElement("g", {
    "data-name": "Layer 2"
  }, t.createElement("g", {
    fill: m.letters,
    "data-name": "Capa 1"
  }, t.createElement("path", {
    d: "M292.37 55.34V55a58.51 58.51 0 0 0-3.74-20.89A54.81 54.81 0 0 0 278 16.61 51.28 51.28 0 0 0 261.19 4.5 51.89 51.89 0 0 0 239.32 0a57.29 57.29 0 0 0-11.43 1.1l-2.06 3.65a50.34 50.34 0 0 1 13.33-1.69 47 47 0 0 1 20.35 4.34 49.72 49.72 0 0 1 15.79 11.5 50.9 50.9 0 0 1 10.13 16.63A55.13 55.13 0 0 1 289 55.19v.3a56.15 56.15 0 0 1-3.5 19.75 49.14 49.14 0 0 1-10.06 16.45 49.74 49.74 0 0 1-15.7 11.37 47.66 47.66 0 0 1-20.29 4.27 47 47 0 0 1-20.32-4.33 49.49 49.49 0 0 1-15.77-11.51 51.14 51.14 0 0 1-10.16-16.61 55.39 55.39 0 0 1-3.57-19.66v-.32a56.06 56.06 0 0 1 3.5-19.66c.15-.37.3-.74.46-1.12h-3.56v.08a58.75 58.75 0 0 0-3.75 20.8v.3A58.76 58.76 0 0 0 190 76.23a54.18 54.18 0 0 0 10.68 17.52 51.25 51.25 0 0 0 16.69 12.13 55.63 55.63 0 0 0 43.83 0A51 51 0 0 0 278 93.75a54.49 54.49 0 0 0 10.67-17.52 58.52 58.52 0 0 0 3.74-20.9M297.95 110.38h3.35V9.14l80.96 101.24h2.9V19.83h-3.37v85.05L300.85 3.66h-2.9v106.72zM408.17 110.38h55.46v-3.05h-52.1V3.55h-3.36v106.83zM460.29 98.31h3.34V9.14l80.96 101.24h2.89V3.66h-3.34v101.22L463.18 3.66h-2.89v94.65z"
  }), t.createElement("path", {
    d: "M434.33 19.84h3.34v78.47h-3.34zM434.33 3.55h3.41V14.5h-3.41zM117.48 2.76H85.96l-26.91 61.1-28.71-61.1H0v107.58h30.43l-.09-54.26 21.04 54.3h14.71l21.02-54.3.11 54.3 30.26-.04V28.72h29.04v-.1h.1v81.76h33.03V28.72h27.99l12.62-25.96H117.48zM562.53 58.16h68.04v-3h-68zm8.34-51.58h66.29v-3h-74.63v3zm67 103.8v-3h-75.34v3z"
  }))));
};

export { h as MtOnline };